import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"arrow-right\"><title>arrow-right</title><g id=\"arrow-right__visibility\"><g id=\"arrow-right_Layer_8-2\" data-name=\"Layer 8\"><path d=\"M13.6085,10.51l-5.36,5.35a.502.502,0,0,1-.71-.71l4.65-4.65-4.65-4.65a.502.502,0,1,1,.71-.71Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-right.svg
// module id = yCD8
// module chunks = 4